<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("SIDENAV.Leagues.edit") }}</h4>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">

          <!-- Start:: Name Input -->
          <base-input col="6" type="text" :placeholder="$t('PLACEHOLDERS.nameAr')" v-model.trim="data.nameAr" required/>
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input col="6" type="text" :placeholder="$t('PLACEHOLDERS.nameEn')" v-model.trim="data.nameEn" required/>
          <!-- End:: Name Input -->
          <!-- Start:: Sport Input -->
          <base-select-input @input="getApiLeague(true)" col="6" :optionsList="sportList"
                             :placeholder="$t('SIDENAV.Sports.name')"
                             v-model="data.sport"/>

          <!--<base-select-input col="6" :optionsList="leaguesList" :placeholder="$t('SIDENAV.Leagues.league')"-->
                             <!--v-model="data.api_league_id"/>-->
          <base-paginated-select ref="childComponent" :api_sport_id="data.sport?.api_sport_id"
                                 :required="true" type="league"
                                 :placeholder="$t('PLACEHOLDERS.choose league')"
                                 col="6" v-model.trim="data.api_league_id"
          />
          
          <!-- End:: Sport Input -->
          <base-image-upload-input col="6" identifier="image" :preSelectedImage="data.image.path"
                                   @selectImage="selectImage" :placeholder="$t('PLACEHOLDERS.image')" required/>
          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch color="green" :label="data.active ? $t('PLACEHOLDERS.active') : $t('PLACEHOLDERS.notActive')"
                      v-model="data.active" hide-details></v-switch>
          </div>

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button class="mt-2" styleType="primary_btn" :btnText="$t('BUTTONS.save')"
                         :isLoading="isWaitingRequest"
                         :disabled="isWaitingRequest"/>
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
  import {debounce} from "lodash";
export default {
  name: "EditLeague",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      sportList: [],
      leaguesList: [],
      total: 10,
      page: 1,
      // Start:: Data Collection To Send
      data: {
        nameAr: null,
        nameEn: null,
        sport: null,
        api_league_id: null,
        api_sport_id: null,
        active: true,
        image: {
          path: null,
          file: null,
        },
      },
      // End:: Data Collection To Send
    };
  },

  computed: {},
  watch: {
    ["data.sport"]: {
      handler() {
        this.debouncedGetCountries();
      },
      immediate: true
    }
  },
  methods: {
    debouncedGetCountries: debounce(function () {
      this.$refs.childComponent.getCountries();
    }, 500),
    debouncedGetLeagues: debounce(function () {
       this.getApiLeague();
    }, 700),
    async getSports() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `sports?page=0&limit=0`,
        });
        this.sportList = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getApiLeague() {
        try {
          let res = await
            this.$axios({
              method: "GET",
              url: `soccer-league`,
              params: {
                league_id:this.data.api_league_id,
              },
            });
          this.data.api_league_id = res.data.data.res.data.name;
        } catch (error) {
          console.log(error.response.data.message);
        }
    },
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.nameAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameAr"));
        return;
      } else if (!this.data.nameEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameEn"));
        return;
      } else if (!this.data.sport) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.sport"));
        return;
      } else {
        this.submitForm();
        return;
      }
    },
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      REQUEST_DATA.append("name[ar]", this.data.nameAr);
      REQUEST_DATA.append("name[en]", this.data.nameEn);
      REQUEST_DATA.append("sport_id", this.data.sport?.id);
      REQUEST_DATA.append("api_league_id", this.data.api_league_id);
      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }
      REQUEST_DATA.append("is_active", +this.data.active);
      REQUEST_DATA.append("_method", "PUT");
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `leagues/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({path: "/leagues/all"});
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    // start show data
    async showLeague() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `leagues/${this.$route.params.id}`,
        });
        this.data.nameAr = res.data.data.League.trans.name.ar;
        this.data.nameEn = res.data.data.League.trans.name.en;
        this.data.active = res.data.data.League.is_active;
        this.data.image.path = res.data.data.League.image;
        this.data.sport = res.data.data.League.sport;
        this.data.api_sport_id = res.data.data.League.api_sport_id;
        this.data.api_league_id = res.data.data.League.api_league_id;
        // await this.getApiLeague(true);
        this.debouncedGetCountries();
        this.debouncedGetLeagues();
        // this.getApiLeague();
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data

  },

  created() {
    this.getSports();
    // Start:: Fire Methods
    this.showLeague();
    // End:: Fire Methods
  },
};
</script>
